{
  "nav": {
    "stats": "Statystyki",
    "registerCatch": "Zarejestruj połów",
    "myCatches": "Moje połowy",
    "myFiskekort": "Moje karty wędkarskie",
    "myBookings": "Moje rezerwacje",
    "profile": "Profil",
    "login": "Zaloguj się",
    "logout": "Wyloguj się",
    "admin": "Admin",
    "valdAdmin": "Zarządzanie valdem",
    "riverAdmin": "Admin rzeki",
    "history": "Historia",
    "buyFiskekort": "Kup kartę wędkarską",
    "registerLink": "Utwórz konto",
    "loggFiskedag": "Loguj dzień wędkowania",
    "contact": "Kontakt",
    "language": "Język",
    "fiskeHer": "Wędkować tutaj",
    "sectionFishing": "Wędkowanie",
    "sectionExplore": "Odkryj",
    "sectionAccount": "Moje konto",
    "sectionManagement": "Zarządzanie",
    "sectionForOwners": "Dla właścicieli",
    "sellFiskekort": "Sprzedaj karty wędkarskie",
    "riverOwnersAssoc": "Stowarzyszenie właścicieli rzek",
    "photoContest": "Konkurs fotograficzny",
    "adminPhotoContest": "Konkurs fotograficzny (admin)",
    "menu": "Menu",
    "openMenu": "Otwórz menu",
    "closeMenu": "Zamknij menu",
    "privacy": "Prywatność",
    "rivers": "Rzeki i rewiry"
  },
  "stats": {
    "title": "Statystyki połowów",
    "filterYear": "Rok",
    "filterMonth": "Miesiąc",
    "filterWeek": "Tydzień",
    "filterDay": "Dzień",
    "totalCatches": "Łączna liczba połowów",
    "totalWeight": "Łączna waga",
    "avgWeight": "Średnia waga",
    "biggestFish": "Największa ryba",
    "released": "Wypuszczone",
    "recentCatches": "Ostatnie połowy",
    "noData": "Brak połowów w wybranym okresie",
    "allRivers": "Wszystkie rzeki",
    "allValds": "Wszystkie valdy",
    "viewVald": "Zobacz stronę valdu →",
    "uniqueAnglers": "Wędkarze",
    "cpue": "Połowy na wędkarza",
    "registerCatchDesc": "Zapisz złowioną rybę z gatunkiem, wagą i długością. Twoje imię domyślnie nie jest wyświetlane publicznie.",
    "startFishingDesc": "Dotknij, gdy zaczynasz wędkować, i „Zakończono wędkowanie”, gdy skończysz. Zapisujemy tylko czas, nigdy Twoją pozycję.",
    "intro": "Lakseborsen to otwarta <b>giełda łososiowa</b>, która na żywo zbiera <b>statystyki łososi</b> z zarejestrowanych norweskich rzek łososiowych i troci wędrownej. Sprawdź aktualne dane o połowach za <b>{{year}}</b> — liczbę połowów, łączną wagę, średnią wagę i największą rybę na rzekę lub odcinek. Przejdź do <history>historii połowów</history>, aby zobaczyć sezony od 2014 roku."
  },
  "catch": {
    "title": "Zarejestruj połów",
    "vald": "Vald (strefa wędkarska)",
    "selectVald": "Wybierz vald…",
    "fishType": "Gatunek ryby",
    "weight": "Waga (kg)",
    "weightKg": "Waga (kg)",
    "length": "Długość (cm)",
    "lengthCm": "Długość (cm)",
    "date": "Data",
    "time": "Godzina",
    "gear": "Sprzęt",
    "photo": "Zdjęcie (opcjonalne)",
    "photoUploadFailed": "Przesyłanie zdjęcia nie powiodło się",
    "released": "Wypuszczone",
    "fromBoat": "Z łodzi",
    "sex": "Płeć (opcjonalnie)",
    "sexTypes": {
      "hann": "Samiec",
      "hunn": "Samica"
    },
    "seaLice": "Wszy morskie",
    "fisher": "Wędkarz",
    "roer": "Wióślarz",
    "onBehalf": {
      "question": "Dla kogo jest ten połów?",
      "self": "Dla mnie",
      "other": "Dla innego wędkarza",
      "fisherName": "Imię wędkarza",
      "fisherNamePlaceholder": "Wpisz imię",
      "recent": "Ostatnio używane"
    },
    "conditions": "Warunki podczas połowu",
    "airTemp": "Temperatura powietrza",
    "precipitation": "Opady",
    "windSpeed": "Prędkość wiatru",
    "waterTemp": "Temperatura wody",
    "waterFlow": "Przepływ wody",
    "nveStationSource": "źródło: {{station}}",
    "weatherPending": "Dane pogodowe dostępne za ok. 5 dni",
    "submit": "Zarejestruj",
    "submitting": "Zapisuję…",
    "success": "Połów zarejestrowany!",
    "offlineDraft": "Zapisano lokalnie — zostanie wysłane automatycznie po połączeniu z internetem",
    "fishTypes": {
      "laks": "Łosoś atlantycki",
      "brunørret": "Pstrąg potokowy",
      "sjøørret": "Tróć wędrowna",
      "pukkellaks": "Łosoś różowy",
      "oppdrettslaks": "Łosoś hodowlany",
      "støing": "Støing",
      "røye": "Golec arktyczny",
      "ørret": "Tróć wędrowna"
    },
    "gearTypes": {
      "flue": "Wędkowanie na muchę",
      "wobbler": "Wobbler",
      "spinner": "Błystka obrotowa",
      "sluk": "Błystka ważka",
      "mark_orm": "Robak / przynęta",
      "rapala": "Rapala",
      "annet": "Inne"
    },
    "errors": {
      "valdRequired": "Wybierz strefę połowu",
      "weightInvalid": "Waga musi wynosić od 0.1 do 100 kg",
      "lengthInvalid": "Długość musi wynosić od 5 do 250 cm",
      "dateRequired": "Podaj datę i godzinę",
      "fisherNameRequired": "Podaj imię wędkarza"
    },
    "fishingDayPrompt": "Łowiłeś dziś bez połowu?",
    "logFishingDay": "Zapisz dzień połowów",
    "logFishingDayDone": "Dzień połowów zapisany ✓",
    "edit": "Edytuj",
    "editTitle": "Edytuj połów",
    "editSave": "Zapisz zmiany",
    "editSaved": "Połów zaktualizowany!",
    "locate": {
      "button": "Użyj mojej lokalizacji",
      "locating": "Ustalanie lokalizacji…",
      "found": "Znaleziono najbliższe vald: {{vald}}",
      "unsupported": "Lokalizacja nie jest obsługiwana w tej przeglądarce",
      "denied": "Musisz zezwolić na dostęp do lokalizacji, aby z tego skorzystać",
      "failed": "Nie udało się ustalić lokalizacji",
      "noneFound": "Żadne pobliskie vald nie ma jeszcze danych lokalizacyjnych"
    },
    "photoPendingOffline": "Zdjęcie zostanie przesłane automatycznie, gdy wrócisz do sieci",
    "photoChange": "Zmień zdjęcie",
    "photoAdd": "Dodaj zdjęcie",
    "photoPreviewAlt": "Podgląd",
    "fishingDayOffline": "Zapisano lokalnie — zostanie zarejestrowane automatycznie, gdy będziesz online",
    "showNamePublic": "Pokaż moje imię publicznie",
    "showNamePublicDesc": "Domyślnie wyłączone. Połów i tak liczy się w statystykach."
  },
  "bulk": {
    "title": "Rejestracja małych ryb (zbiorczo)",
    "intro": "Złapałeś wiele małych pstrągów? Zarejestruj je wszystkie naraz.",
    "count": "Liczba ryb",
    "countHint": "Rejestrowanie {{count}} ryb",
    "allReleased": "Wszystkie wypuśczone",
    "optionalMeasurements": "Opcjonalne pomiary (pozostaw puste jeśli nieznane)",
    "avgWeight": "Średniak waga (kg)",
    "avgLength": "Średnia długość (cm)",
    "lengthHint": "Zazwyczaj poniżej 40 cm",
    "submit": "Zarejestruj {{count}} ryb",
    "submitting": "Rejestrowanie…",
    "success": "{{count}} ryb zarejestrowanych!",
    "successDetail": "Połowy zostały zapisane i pojawią się w statystykach.",
    "registerMore": "Zarejestruj więcej",
    "backToForm": "Standardowa rejestracja",
    "bulkLink": "Złapałeś wiele małych pstrągów? → Rejestracja zbiorcza",
    "errors": {
      "countInvalid": "Liczba musi być od 1 do 50"
    },
    "decreaseCount": "Zmniejsz",
    "increaseCount": "Zwiększ"
  },
  "myCatches": {
    "title": "Moje połowy",
    "empty": "Nie zarejestrowałeś jeszcze żadnych połowów.",
    "registerFirst": "Zarejestruj swój pierwszy połów",
    "exportCsv": "Pobierz moje połowy",
    "exportError": "Nie udało się pobrać połowów"
  },
  "profile": {
    "title": "Mój profil",
    "displayName": "Imię",
    "language": "Język",
    "save": "Zapisz",
    "saved": "Zapisano!",
    "security": "Bezpieczeństwo",
    "passkey": "Passkey (logowanie biometryczne)",
    "passkeyDesc": "Loguj się szybko za pomocą odcisku palca, rozpoznawania twarzy lub klucza bezpieczeństwa.",
    "registerPasskey": "Zarejestruj passkey",
    "addPasskey": "Dodaj kolejny passkey",
    "passkeyDefaultLabel": "Passkey",
    "passkeyAdded": "Dodano {{date}}",
    "deletePasskey": "Usuń",
    "confirmDeletePasskey": "Usunąć passkey \"{{label}}\"?",
    "hideNamePublic": "Pokazuj moje połowy anonimowo",
    "hideNamePublicDesc": "Twoje imię będzie ukryte w publicznych zestawieniach połowów. Połowy nadal będą wliczane do statystyk.",
    "deleteAccount": "Usuń konto",
    "deleteAccountDesc": "Usuwa Twoje imię, e-mail i inne dane osobowe z profilu. Twoje połowy pozostaną zachowane w formie anonimowej, zgodnie z wymogami prawa dotyczącymi raportowania połowów.",
    "confirmDeleteAccount": "Czy na pewno chcesz usunąć swoje konto? Tej operacji nie można cofnąć.",
    "privacy": "Prywatność",
    "privacyDesc": "Pobierz wszystkie dane, które o Tobie przechowujemy. Zobacz też politykę prywatności (po norwesku).",
    "exportData": "Pobierz moje dane"
  },
  "admin": {
    "title": "Panel administracyjny",
    "totalCatches": "Łącznie połowów",
    "catchesThisYear": "Połowy w tym roku",
    "totalFishers": "Aktywni wędkarze",
    "totalUsers": "Zarejestrowani użytkownicy",
    "tabCatches": "Połowy",
    "tabUsers": "Użytkownicy",
    "dateFrom": "Od daty",
    "dateTo": "Do daty",
    "allFishTypes": "Wszystkie gatunki",
    "allReleased": "Wszystkie",
    "keptOnly": "Tylko zatrzymane",
    "releasedOnly": "Tylko wypuszczone",
    "applyFilters": "Filtruj",
    "resetFilters": "Resetuj",
    "catchCount": "{{count}} połowów",
    "exportCsv": "Pobierz CSV",
    "deleteSelected": "Usuń zaznaczone ({{count}})",
    "confirmBulkDeleteCatches": "Usunąć {{count}} połów(ów)? Tej operacji nie można cofnąć.",
    "bulkDeleteDone": "Usunięto {{count}} połów(ów).",
    "selectAllOnPage": "Zaznacz wszystkie na stronie",
    "selectRow": "Zaznacz wiersz",
    "fisher": "Wędkarz",
    "yes": "Tak",
    "no": "Nie",
    "prevPage": "Poprzednia",
    "nextPage": "Następna",
    "userName": "Imię",
    "userEmail": "E-mail",
    "userRole": "Rola",
    "userCatches": "Połowy",
    "registered": "Zarejestrowany",
    "role_fisher": "Wędkarz",
    "role_admin": "Admin",
    "promote": "Mianuj adminem",
    "demote": "Usuń admina",
    "tabValds": "Odcinki",
    "valdName": "Odcinek",
    "valdRiver": "Rzeka",
    "valdOwner": "Właściciel",
    "valdNoOwner": "Brak właściciela",
    "assignOwner": "Przypisz właściciela",
    "clearOwner": "Usuń właściciela",
    "searchVald": "Szukaj strefy…",
    "searchUser": "Szukaj użytkownika (imię lub e-mail)…",
    "search": "Szukaj",
    "select": "Wybierz",
    "filterRiver": "Filtruj według rzeki",
    "allRivers": "Wszystkie rzeki",
    "searchUsers": "Szukaj po nazwie lub e-mailu…",
    "ownedValds": "Odcinki",
    "selectVald": "Wybierz odcinek…",
    "assignVald": "Przypisz odcinek",
    "removeValdOwner": "Usuń własność",
    "role_river_admin": "Admin rzeki",
    "promoteRiverAdmin": "Zrób adminem rzeki",
    "demoteRiverAdmin": "Usuń admina rzeki",
    "selectRiver": "Wybierz rzekę…",
    "selectRiverSystem": "Wybierz system rzeczny…",
    "makeRiverAdmin": "Zrób adminem rzeki",
    "inviteOwner": "Zaproś właściciela łowiska",
    "inviteHint": "Wprowadź adres e-mail przyszłego właściciela łowiska.",
    "inviteEmailPlaceholder": "E-mail właściciela",
    "sendInvite": "Wyślij zaproszenie",
    "inviteSentOk": "Zaproszenie wysłane do {{email}}",
    "inviteAssignedDirect": "{{email}} jest już użytkownikiem i zostało przypisane mu właścicielstwo",
    "pendingInvite": "Oczekiwanie na {{email}}",
    "edit": "Edytuj",
    "riverClosed": "Tymczasowo zamknięta",
    "riverDescription": "Opis",
    "riverFishingRules": "Zasady wędkowania",
    "riverFlags": "Status",
    "riverMain": "Rzeka główna",
    "riverMunicipalities": "Gmina",
    "riverName": "Nazwa",
    "riverNveId": "ID stacji NVE",
    "riverNveName": "Nazwa stacji NVE",
    "riverRequiresDisinfection": "Wymaga dezynfekcji",
    "riverSeason": "Sezon",
    "riverSeasonClose": "Koniec sezonu (MM-DD)",
    "riverSeasonOpen": "Początek sezonu (MM-DD)",
    "riverSystem": "System",
    "searchRiver": "Szukaj rzeki (nazwa, gmina, system)…",
    "tabRivers": "Rzeki"
  },
  "riverAdmin": {
    "title": "Admin rzeki",
    "totalCatches": "Łączne połowy",
    "catchesThisYear": "Połowy w tym roku",
    "allYears": "Wszystkie lata",
    "exportCsv": "Pobierz Excel",
    "exportError": "Nie udało się pobrać Excel",
    "tabs": {
      "fangster": "Połowy",
      "valds": "Odcinki",
      "elver": "Rzeki",
      "meldinger": "Wiadomości",
      "vilkar": "Warunki",
      "rettelser": "Korekty",
      "fisketrykk": "Presja wędkarska",
      "elvekort": "Elvekort"
    },
    "rivers": {
      "title": "Sezon i zamknięcia",
      "hint": "Ustaw daty sezonu dla każdej rzeki. Tymczasowe zamknięcia są wyświetlane wędkarzom.",
      "seasonOpen": "Sezon otwiera się",
      "seasonClose": "Sezon kończy się",
      "month": "Miesiąc",
      "day": "Dzień",
      "temporarilyClosed": "Tymczasowo zamknięta",
      "temporarilyClosedHint": "Wyświetla ostrzeżenie 'Tymczasowo zamknięta' na publicznej stronie rzeki. Wędkarze mogą nadal rejestrować połowy i kupować karty wędkarskie.",
      "requiresDisinfection": "Wymagana dezynfekcja",
      "requiresDisinfectionHint": "Wędkarze muszą potwierdzić metodę dezynfekcji przy zakupie karty",
      "save": "Zapisz",
      "saved": "Zapisano ✓",
      "fishingRules": "Regulamin (tekst, widoczny publicznie)",
      "fishingRulesPlaceholder": "Wpisz zasady, ograniczenia i inne informacje dla rybałków…",
      "description": "Opis (widoczny publicznie)",
      "descriptionPlaceholder": "Napisz krótki opis rzeki…",
      "images": "Zdjęcia (wyświetlane na stronie rzeki)",
      "addPhoto": "+ Dodaj zdjęcie",
      "municipalities": "Gmina",
      "municipalitiesHint": "Wyświetlane w metadanych SEO i na stronie rzeki. Może być edytowane tylko przez administratora witryny.",
      "municipalitiesPlaceholder": "np. Røyrvik, Namsskogan, Grong, Overhalla, Namsos",
      "stayGuide": "Gdzie się zatrzymać (tekst, widoczny publicznie)",
      "stayGuidePlaceholder": "Wskazówki, gdzie wędkarze mogą się najlepiej zatrzymać: najbliższa miejscowość, co warto zarezerwować wcześniej, miejsca na posiłek, wypożyczalnie sprzętu…",
      "nearbyPlaces": "Hotele i restauracje w pobliżu",
      "placeName": "Nazwa",
      "placeDistance": "Odległość, np. „5 min od Formofoss”",
      "placeDescription": "Krótki opis",
      "addPlace": "+ Dodaj miejsce",
      "seasonEvents": "Co się dzieje w sezonie (wydarzenia)",
      "eventTitle": "Tytuł, np. „Dzień łososia”",
      "eventStart": "Data rozpoczęcia",
      "eventEnd": "Data zakończenia (opcjonalnie)",
      "eventDescription": "Krótki opis",
      "addEvent": "+ Dodaj wydarzenie",
      "placeLat": "Szerokość geogr. (opcjonalnie)",
      "placeLon": "Długość geogr. (opcjonalnie)",
      "placeHighlight": "Tekst od sponsora (wyświetlany jako treść sponsorowana)",
      "placeTags": "Oferta",
      "placeSponsor": "Wspiera rzekę (sponsor)",
      "placePick": "Polecane? Napisz dlaczego (wyświetlane jako „Polecane przez zarząd rzeki”)",
      "placeLogo": "Logo (opcjonalnie)",
      "sponsorReport": "Raport sponsora",
      "sponsorReportMonth": "Miesiąc",
      "sponsorReportLinks": "Kliknięcia linku",
      "sponsorReportMap": "Pokaż na mapie",
      "sponsorReportCopy": "Kopiuj tekst",
      "sponsorReportCopied": "Skopiowano",
      "sponsorReportHint": "Liczy kliknięcia linku sponsora i „Pokaż na mapie”. Nie zapisujemy danych osobowych.",
      "sponsorReportText": "{{name}}: w {{month}} Twój link kliknięto {{link}} razy, a „Pokaż na mapie” użyto {{map}} razy.",
      "sub": {
        "season": "Sezon",
        "content": "Treść",
        "nearby": "W pobliżu",
        "sponsors": "Sponsorzy"
      },
      "selectRiver": "Wybierz rzekę",
      "systemPlacesNote": "Dotyczy wszystkich rzek w {{system}}. Dodaj miejsce raz, a pojawi się na wszystkich rzekach.",
      "sponsorReportEmpty": "Brak sponsorów. W sekcji „W pobliżu” zaznacz przy wpisie „Wspiera rzekę (sponsor)”. Sponsorzy pojawią się tu z liczbą kliknięć miesięcznie.",
      "placeFamily": "Dla całej rodziny (także dla niewędkarzy)",
      "placePhone": "Telefon",
      "placeImage": "Zdjęcie (sponsor)",
      "sponsorTier_none": "Brak sponsora",
      "sponsorTier_friend": "Przyjaciel rzeki",
      "sponsorTier_local": "Lokalne wsparcie",
      "sponsorTier_supporter": "Wspierający",
      "sponsorTier_partner": "Partner",
      "sponsorTier_main": "Sponsor główny"
    },
    "valds": {
      "title": "Odcinki",
      "ownerLabel": "Właściciel",
      "noOwner": "Brak właściciela",
      "assignOwner": "Zmień właściciela",
      "clearOwner": "Usuń właściciela",
      "searchUsers": "Szukaj użytkownika (imię lub e-mail)…"
    },
    "messaging": {
      "title": "Wyślij wiadomość",
      "recipients": "Odbiorcy",
      "recipientValdeiere": "Właściciele odcinków",
      "recipientFishers": "Wędkarze",
      "recipientAll": "Wszyscy",
      "subject": "Temat",
      "body": "Wiadomość",
      "send": "Wyślij wiadomość",
      "sending": "Wysyłanie…",
      "sent": "Wysłano do {{count}} odbiorców",
      "sentCount": "Wysłano",
      "history": "Wysłane wiadomości",
      "empty": "Brak wysłanych wiadomości",
      "recipientCustom": "Osoby indywidualne",
      "emailToggle": "Wyślij też e-mailem ({{count}} z e-mailem)",
      "previewCount": "{{count}} odbiorców",
      "noRecipients": "Nie znaleziono odbiorców",
      "sendBtn": "Wyślij do {{count}} odbiorców"
    }
  },
  "notifications": {
    "title": "Powiadomienia",
    "markAllRead": "Oznacz wszystkie jako przeczytane",
    "empty": "Brak powiadomień",
    "typeMessageReceived": "Nowa wiadomość",
    "typeValdOwnerAssigned": "Odcinek przydzielony"
  },
  "common": {
    "loading": "Ładowanie…",
    "noResults": "Brak wyników",
    "error": "Coś poszło nie tak",
    "retry": "Spróbuj ponownie",
    "kg": "kg",
    "cm": "cm",
    "back": "Wstecz",
    "clear": "Wyczyść",
    "delete": "Usuń",
    "paymentMethods": "Akceptujemy Vipps, kartę (Visa/Mastercard) i MobilePay.",
    "cancel": "Anuluj",
    "save": "Zapisz",
    "previousMonth": "Poprzedni miesiąc",
    "nextMonth": "Następny miesiąc"
  },
  "auth": {
    "loginRequired": "Zaloguj się, aby kontynuować",
    "loginForCatch": "Zaloguj się, aby zarejestrować połów",
    "loginForMyCatches": "Zaloguj się, aby zobaczyć swoje połowy",
    "loginForProfile": "Zaloguj się, aby zobaczyć swój profil",
    "loginHint": "Możesz zalogować się przez Google, link e-mail lub hasło",
    "registerHint": "Nowy użytkownik?",
    "registerLink": "Utwórz konto"
  },
  "history": {
    "title": "Historia połowów",
    "year": "Rok",
    "week": "Tydzień",
    "weekLabel": "Tydzień {{week}}",
    "allWeeks": "Wszystkie tygodnie",
    "colTime": "Czas",
    "colFish": "Gatunek",
    "colWeight": "Waga",
    "colLength": "Długość",
    "colGear": "Sprzęt",
    "colVald": "Vald",
    "colFisher": "Wędkarz",
    "colReleased": "Wypuszczono"
  },
  "valdPage": {
    "river": "Rzeka",
    "owner": "Właściciel",
    "noOwner": "Niedostępne",
    "catchesThisYear": "Połowy w tym roku",
    "fiskekortTitle": "Karty wędkarskie",
    "noFiskekort": "Brak kart wędkarskich dla tego valdu",
    "loginToBook": "Zaloguj się, aby kupić kartę",
    "buy": "Kup",
    "price": "Cena",
    "durationDay": "{{count}} dzień",
    "durationDays": "{{count}} dni",
    "seasonLabel": "Sezon",
    "unlimited": "Nieograniczone",
    "available": "Dostępne",
    "remaining": "{{count}} dostępnych",
    "soldOut": "Wyprzedane",
    "seasonOpens": "Sezon otwiera się {{date}}",
    "seasonEnded": "Sezon zakończył się",
    "preBook": "Rezerwacja wstępna",
    "packagesTitle": "Pakiety",
    "noPackages": "Brak pakietów",
    "packageIncludes": "Zawiera",
    "combinedPrice": "Cena łączna: {{price}} kr",
    "orderPackageBtn": "Zamów pakiet",
    "accommodationTitle": "Zakwaterowanie",
    "accommodationNoCardRequired": "Karta wędkarska nie jest wymagana – każdy może zarezerwować nocleg.",
    "noAccommodation": "Brak zakwaterowania",
    "capacity": "{{count}} osoba",
    "capacity_plural": "{{count}} osób",
    "perNight": "/ noc",
    "book": "Zarezerwuj",
    "accommodationType_hytte": "Domek",
    "accommodationType_rom": "Pokój",
    "accommodationType_telt": "Miejsce namiotowe",
    "accommodationType_campingvogn": "Przyczepa",
    "accommodationType_annet": "Inne",
    "omOssTitle": "O nas",
    "contactPhone": "Telefon",
    "contactEmail": "E-mail",
    "contactWebsite": "Strona internetowa",
    "tilgjengelighet": "Dostępność",
    "avstandBilvei": "Odległość od drogi",
    "editVald": "Edytuj wędkownię",
    "fishingSpotsTitle": "Miejsca połowów",
    "seePermits": "Zobacz karty wędkarskie"
  },
  "fiskekort": {
    "purchaseTitle": "Kup kartę wędkarską",
    "product": "Produkt",
    "vald": "Vald",
    "validFrom": "Pierwszy dzień",
    "validTo": "Ważna do",
    "price": "Cena",
    "confirm": "Potwierdź zakup",
    "submitting": "Kupowanie…",
    "success": "Karta zakupiona!",
    "successDescription": "Twoja karta jest teraz aktywna.",
    "viewMyCards": "Moje karty",
    "currency": "NOK",
    "paymentProcessing": "Przetwarzanie płatności…",
    "paymentCancelled": "Płatność anulowana",
    "paymentCancelledDesc": "Możesz spróbować ponownie kupić zezwolenie.",
    "paymentPending": "Płatność otrzymana",
    "paymentPendingDesc": "Czekamy na potwierdzenie od dostawcy płatności. Twoje zezwolenie pojawi się w sekcji Moje pozwolenia po potwierdzeniu.",
    "seasonNote": "Sezon: {{open}} – {{close}}",
    "errorBeforeSeason": "Wybrana data jest poza sezonem. Sezon otwiera się {{open}}.",
    "errorAfterSeason": "Zezwolenie wykracza poza koniec sezonu ({{close}}). Wybierz wcześniejszą datę rozpoczęcia.",
    "disinfectionTitle": "Dezynfekcja (wymagana)",
    "disinfectionHint": "Ta rzeka wymaga potwierdzenia, że sprzęt i/lub łódź została zdezynfekowana zgodnie z przepisami.",
    "disinfectionRequired": "Musisz wybrać metodę dezynfekcji.",
    "disinfectionMethod": {
      "dried_2weeks": "Wysuszone (min. 2 tygodnie)",
      "frozen": "Mrożone",
      "heat_treated": "Obrobione termicznie (min. 60 °C)",
      "chemical": "Zdezynfekowane chemicznie"
    },
    "quantity": "Liczba kart wędkarskich",
    "totalPrice": "Łączna cena"
  },
  "myFiskekort": {
    "title": "Moje karty wędkarskie",
    "empty": "Nie masz jeszcze żadnych kart.",
    "validFrom": "Od",
    "validTo": "Do",
    "status": "Status",
    "status_confirmed": "Aktywna",
    "status_cancelled": "Anulowana",
    "status_pending": "Oczekująca",
    "vald": "Vald",
    "product": "Typ",
    "price": "Zapłacono",
    "bookAgain": "Zarezerwuj ponownie →",
    "showProof": "Pokaż dowód",
    "registerCatch": "Zarejestruj połów"
  },
  "myBookings": {
    "title": "Moje rezerwacje",
    "empty": "Nie masz jeszcze żadnych rezerwacji.",
    "listing": "Zakwaterowanie",
    "checkIn": "Przyjazd",
    "checkOut": "Wyjazd",
    "guests": "Goście",
    "total": "Łącznie",
    "status_confirmed": "Potwierdzona",
    "status_cancelled": "Anulowana",
    "status_pending": "Oczekująca",
    "cancelBtn": "Anuluj rezerwację",
    "cancelConfirm": "Czy na pewno chcesz anulować tę rezerwację?",
    "cancelling": "Anulowanie…",
    "cancelError": "Nie można anulować. Spróbuj ponownie.",
    "refundNote": "Rezerwacja anulowana. Ewentualny zwrot zostanie przetworzony ręcznie w ciągu 5 dni roboczych."
  },
  "valdAdmin": {
    "title": "Zarządzanie valdem",
    "myValds": "Moje valdy",
    "selectVald": "Wybierz vald do zarządzania",
    "searchVald": "Szukaj valdу…",
    "catchesThisYear": "Połowy w tym roku",
    "totalCatches": "Łączne połowy",
    "fiskekortTitle": "Karty wędkarskie",
    "addProduct": "Dodaj kartę",
    "editProduct": "Edytuj",
    "deactivateProduct": "Dezaktywuj",
    "noProducts": "Brak skonfigurowanych kart",
    "description": "Opis",
    "savedDescription": "Zapisano!",
    "saveDescription": "Zapisz opis",
    "purchasesTitle": "Sprzedane karty",
    "noPurchases": "Brak sprzedaży",
    "productName": "Nazwa",
    "productPrice": "Cena (øre)",
    "productDuration": "Czas trwania (dni)",
    "productSeasonStart": "Początek sezonu (YYYY-MM-DD)",
    "productSeasonEnd": "Koniec sezonu (YYYY-MM-DD)",
    "productQuota": "Limit (puste = nieograniczony)",
    "save": "Zapisz",
    "cancel": "Anuluj",
    "saving": "Zapisywanie…",
    "confirmDeactivate": "Dezaktywować ten produkt?",
    "confirmForceDeleteProduct": "Produkt ma potwierdzone zakupy. Usunąć trwale (wraz ze wszystkimi zakupami)? Tej operacji nie można cofnąć.",
    "purchaseFisher": "Wędkarz",
    "purchaseProduct": "Produkt",
    "purchaseValid": "Ważność",
    "purchaseStatus": "Status",
    "purchasePaid": "Zapłacono",
    "backToValds": "Powrót do listy valdów",
    "viewPublicPage": "Zobacz stronę publiczną",
    "tabFiskekort": "Karty wędkarskie",
    "tabAccommodation": "Zakwaterowanie",
    "tabPackages": "Pakiety",
    "tabSettings": "Ustawienia",
    "tabRevenue": "Przychody",
    "addListing": "Dodaj zakwaterowanie",
    "editListing": "Edytuj",
    "deactivateListing": "Dezaktywuj",
    "activateListing": "Aktywuj",
    "managePhotos": "Zdjęcia",
    "addPhoto": "Dodaj zdjęcie",
    "deletePhoto": "Usuń zdjęcie",
    "uploadingPhoto": "Przesyłanie...",
    "confirmDeletePhoto": "Usunąć to zdjęcie?",
    "noListings": "Brak ofert zakwaterowania",
    "listingName": "Nazwa",
    "listingType": "Typ",
    "listingCapacity": "Kapacytet (osoby)",
    "listingPrice": "Cena za noc (øre)",
    "listingDesc": "Opis",
    "listingProximityNote": "Odległość do łowiska",
    "listingProximityNotePlaceholder": "np. 5 min jazdy od strefy 2",
    "listingOpenFrom": "Otwarte od (MM-DD)",
    "listingOpenTo": "Otwarte do (MM-DD)",
    "listingMinNights": "Min. nocy",
    "listingMaxNights": "Maks. nocy",
    "blockedPeriods": "Zablokowane okresy",
    "noBlockedPeriods": "Brak zablokowanych okresów.",
    "addBlockedPeriod": "Dodaj blokadę",
    "blockedFrom": "Od",
    "blockedTo": "Do",
    "blockedReason": "Powód (opcjonalnie)",
    "blockedReasonHint": "np. Konserwacja",
    "bookingsTitle": "Prośby o rezerwację: {{name}}",
    "noBookings": "Brak próśb",
    "bookingGuest": "Gość",
    "bookingDates": "Daty",
    "bookingStatus": "Status",
    "bookingConfirm": "Potwierdź",
    "bookingCancel": "Odmów",
    "bookingStatus_pending": "Oczekuje",
    "bookingStatus_confirmed": "Potwierdzone",
    "bookingStatus_cancelled": "Odmówione",
    "addPackage": "Dodaj pakiet",
    "editPackage": "Edytuj",
    "deletePackage": "Usuń",
    "noPackages": "Brak pakietów",
    "packageName": "Nazwa",
    "packageDesc": "Opis",
    "packageFiskekort": "Karta wędkarska (opcjonalnie)",
    "packageAccommodation": "Zakwaterowanie (opcjonalnie)",
    "packageCombinedPrice": "Cena łączna w øre (opcjonalnie)",
    "packageNone": "— brak —",
    "contactTitle": "Kontakt (O nas)",
    "contactName": "Nazwa / organizacja",
    "contactPhone": "Telefon",
    "contactEmail": "E-mail",
    "contactWebsite": "Strona internetowa",
    "saveContact": "Zapisz kontakt",
    "fishingOptionsTitle": "Opcje wędkowania",
    "suitableForFlyFishing": "Odpowiednie do wędkowania muchowego",
    "fishingFromBoat": "Wędkowanie z łodzi dostępne",
    "saveFishingOptions": "Zapisz opcje wędkowania",
    "seasonPicker": {
      "yearRound": "Cały rok",
      "yearRoundNote": "Dostępne przez cały rok",
      "selectStart": "Wybierz datę początku",
      "selectEnd": "wybierz datę końca"
    },
    "calendarPreview": "Pokaż podgląd kalendarza",
    "calendarPreviewHide": "Ukryj podgląd kalendarza",
    "setupChecklist": {
      "title": "Pierwsze kroki – skonfiguruj swój vald",
      "step1": "Opisz vald",
      "step2": "Dodaj produkt karty wędkarskiej",
      "step3": "Dodaj nocleg",
      "step4": "Utwórz pakiet",
      "optional": "opcjonalnie",
      "packageHint": "Najpierw utwórz produkt karty wędkarskiej i ofertę noclegu, zanim utworzysz pakiet."
    }
  },
  "accommodation": {
    "bookTitle": "Rezerwacja zakwaterowania",
    "listing": "Zakwaterowanie",
    "checkIn": "Zameldowanie",
    "checkOut": "Wymeldowanie",
    "guestCount": "Liczba gości",
    "guestName": "Twoje imię i nazwisko",
    "guestEmail": "E-mail",
    "guestPhone": "Telefon (opcjonalnie)",
    "notes": "Wiadomość do właściciela (opcjonalnie)",
    "totalPrice": "Cena łączna",
    "totalNights": "{{count}} noc",
    "totalNights_plural": "{{count}} noce",
    "bookBtn": "Wyślij prośbę o rezerwację",
    "submitting": "Wysyłanie…",
    "success": "Wysłano!",
    "successDetail": "Właściciel skontaktuje się z Tobą.",
    "loginRequired": "Musisz się zalogować, aby zarezerwować zakwaterowanie",
    "perNight": "/ noc",
    "datesUnavailable": "Te daty są niedostępne, wybierz inne daty",
    "paymentProcessing": "Przetwarzanie płatności…",
    "paymentConfirmed": "Płatność potwierdzona!",
    "paymentConfirmedDesc": "Rezerwacja potwierdzona. Czekamy na Twój przyjazd!",
    "paymentCancelled": "Płatność anulowana",
    "paymentCancelledDesc": "Płatność została anulowana. Możesz spróbować ponownie.",
    "paymentPending": "Płatność oczekuje",
    "paymentPendingDesc": "Płatność nie została jeszcze potwierdzona. Sprawdź Moje rezerwacje za chwilę.",
    "viewMyBookings": "Zobacz moje rezerwacje",
    "unavailablePeriods": "Zarezerwowane okresy",
    "blockedPeriods": "Zablokowane okresy",
    "seasonWindow": "Sezon otwarty {{from}} – {{to}}",
    "minNightsHint": "Minimum {{count}} nocy",
    "maxNightsHint": "Maksimum {{count}} nocy",
    "minNightsError": "Wymagane co najmniej {{count}} noce",
    "maxNightsError": "Dozwolone maksimum {{count}} nocy",
    "outsideSeason": "Wybrane daty są poza sezonem"
  },
  "fiskekortList": {
    "title": "Dostępne karty wędkarskie",
    "intro": "Przeglądaj i kupuj karty wędkarskie",
    "noProducts": "Brak dostępnych kart wędkarskich w tej chwili",
    "buy": "Kup",
    "soldOut": "Wyprzedane",
    "unlimited": "Nieograniczone",
    "remaining": "Pozostało {{count}}",
    "durationDay": "1 dzień",
    "durationDays": "{{count}} dni",
    "calendarView": "Kalendarz",
    "listView": "Lista",
    "noProductsDay": "Brak kart wędkarskich w tym dniu",
    "legendAvailable": "Dostępne",
    "legendSoldOut": "Wyprzedane"
  },
  "fishingDay": {
    "title": "Loguj dzień wędkowania",
    "intro": "Zarejestruj, że łowiłeś dziś bez złowienia czegokolwiek.",
    "submit": "Loguj dzień wędkowania",
    "submitting": "Zapisywanie…",
    "success": "Dzień wędkowania zarejestrowany!",
    "successCta": "Chcesz zarejestrować połów?",
    "calendarTitle": "Twoje dni wędkowania",
    "noCatches": "brak połowu",
    "catchCount_one": "{{count}} połów",
    "catchCount_other": "{{count}} połowy",
    "delete": "Usuń",
    "confirmDelete": "Usunąć ten dzień wędkowania?"
  },
  "contact": {
    "title": "Kontakt",
    "intro": "Masz pytania lub uwagi? Wyślij nam wiadomość, a odpowiemy tak szybko, jak to możliwe.",
    "name": "Imię i nazwisko",
    "email": "Adres e-mail",
    "message": "Wiadomość",
    "send": "Wyślij wiadomość",
    "sending": "Wysyłanie...",
    "successMessage": "Dziękujemy! Otrzymaliśmy Twoją wiadomość i wkrótce odpiszemy.",
    "errorMessage": "Coś poszło nie tak. Spróbuj ponownie."
  },
  "revenue": {
    "title": "Przychody",
    "year": "Rok",
    "fiskekortTotal": "Licencje wędkarskie",
    "bookingsTotal": "Zakwaterowanie",
    "grandTotal": "Łącznie",
    "fiskekortSales": "Sprzedane licencje",
    "accommodationBookings": "Rezerwacje zakwaterowania",
    "noData": "Brak danych dla wybranego roku.",
    "exportCsv": "Pobierz CSV",
    "product": "Produkt",
    "date": "Data",
    "amount": "Kwota",
    "listing": "Obiekt",
    "checkIn": "Przyjazd",
    "checkOut": "Wyjazd",
    "guest": "Gość",
    "payoutStatus": "Wypłacono",
    "payoutDone": "Tak",
    "payoutPending": "Nie"
  },
  "packageOrder": {
    "title": "Zamów pakiet",
    "priceBreakdown": "Zestawienie cen",
    "fiskekortPart": "Karta wędkarska",
    "accommodationPart": "Zakwaterowanie",
    "combinedTotal": "Cena łączna",
    "validFrom": "Początek karty (zameldowanie)",
    "checkIn": "Zameldowanie",
    "checkOut": "Wymeldowanie",
    "guestCount": "Liczba gości",
    "guestName": "Twoje imię i nazwisko",
    "guestEmail": "E-mail",
    "guestPhone": "Telefon (opcjonalnie)",
    "notes": "Wiadomość (opcjonalnie)",
    "submitBtn": "Zamów i zapłać",
    "submitting": "Wysyłanie…",
    "paymentProcessing": "Przetwarzanie płatności…",
    "paymentConfirmed": "Pakiet zamówiony!",
    "paymentConfirmedDesc": "Karta wędkarska i zakwaterowanie potwierdzone. Wiele ryb!",
    "paymentPending": "Płatność w toku",
    "paymentPendingDesc": "Płatność jeszcze nie potwierdzona. Sprawdź Moje zamówienia za chwilę.",
    "paymentCancelled": "Płatność anulowana",
    "paymentCancelledDesc": "Możesz spróbować ponownie.",
    "viewMyBookings": "Moje rezerwacje",
    "loginRequired": "Musisz się zalogować, aby zamówić pakiet"
  },
  "riverPage": {
    "notFound": "Rzeka nie znaleziona",
    "temporarilyClosed": "Tymczasowo zamknięta",
    "requiresDisinfection": "Wymagana dezynfekcja",
    "packagesSection": "Pakiety — zezwolenie + zakwaterowanie",
    "valdsSection": "Strefy wędkarskie i zezwolenia",
    "accommodationSection": "Zakwaterowanie",
    "viewVald": "Zobacz strefę",
    "noValds": "Brak zarejestrowanych stref",
    "noProductsForVald": "Brak dostępnych zezwoleń",
    "mapSection": "Mapa rzeki",
    "fishingRulesTitle": "Regulamin połowów",
    "eventsSection": "Co się dzieje w sezonie",
    "staySection": "Nocleg, jedzenie i atrakcje nad {{name}}",
    "readMore": "Czytaj więcej",
    "placeCategory_hotel": "Hotel",
    "placeCategory_restaurant": "Restauracja",
    "placeCategory_camping": "Kemping",
    "placeCategory_cabin": "Domki",
    "placeCategory_shop": "Sklep",
    "placeCategory_other": "Inne",
    "filterValds": "Szukaj valdów…",
    "noValdMatch": "Żaden vald nie pasuje do wyszukiwania",
    "fromPrice": "od {{price}}",
    "cardCount_one": "{{count}} karta",
    "cardCount_few": "{{count}} karty",
    "cardCount_many": "{{count}} kart",
    "cardCount_other": "{{count}} karty",
    "noCardsAvailable": "Brak dostępnych kart",
    "showAllValds": "Pokaż wszystkie valdy ({{count}})",
    "seePermits": "Zobacz karty wędkarskie",
    "nearbyFilter_all": "Wszystkie",
    "nearbyFilter_stay": "Nocleg",
    "nearbyFilter_eat": "Jedzenie",
    "nearbyFilter_shop": "Sklepy",
    "nearbyFilter_other": "Inne",
    "nearbyNear": "Najbliżej",
    "nearbyNearNone": "Nie wybrano",
    "nearbyDistance": "{{km}} km w linii prostej od {{vald}}",
    "nearbyBookable": "Można zarezerwować tutaj",
    "nearbyAd": "Treść sponsorowana",
    "nearbyTag_fiskekort": "Sprzedaje karty wędkarskie",
    "nearbyTag_tackle": "Sprzęt wędkarski",
    "nearbyTag_guide": "Przewodnik",
    "nearbyTag_boat": "Wypożyczalnia łodzi",
    "nearbyTag_drying": "Suszarnia",
    "nearbyTag_freezer": "Zamrażarka",
    "nearbyTag_earlyBreakfast": "Wczesne śniadanie",
    "mapLayer_valds": "Valds",
    "mapLayer_spots": "Miejsca połowu",
    "nearbySponsor": "Wspiera {{river}}",
    "nearbyPick": "Polecane przez zarząd rzeki",
    "nearbyShowOnMap": "Pokaż na mapie",
    "sponsorsRow": "Wspierają nas",
    "placeCategory_attraction": "Atrakcja",
    "nearbyFilter_see": "Atrakcje",
    "nearbyFilter_family": "Rodzina",
    "nearbyFamily": "Dla całej rodziny",
    "nearbyVisit": "Odwiedź stronę",
    "nearbyCall": "Zadzwoń",
    "sponsorMain": "Sponsor główny"
  },
  "fiskekortBevis": {
    "statusActive": "Aktywny — zezwolenie ważne",
    "refLabel": "Nr ref.",
    "print": "Drukuj / Udostępnij",
    "catchCtaText": "Coś złapałeś? Pamiętaj o zarejestrowaniu połowu!",
    "catchCtaBtn": "Zarejestruj połów"
  },
  "discovery": {
    "title": "Znajdź pozwolenia na połów w norweskich rzekach łososiowych",
    "intro": "Przeglądaj łowiska i kupuj pozwolenia od właścicieli sprzedających przez Lakseborsen. Filtruj według rzeki, techniki wędkowania lub dostępności.",
    "filterRiver": "Filtruj według rzeki",
    "allRivers": "Wszystkie rzeki",
    "flyFishing": "Muchówkowanie",
    "boatFishing": "Łowienie z łodzi",
    "hasFiskekort": "Karta wędkarska",
    "clearFilters": "Wyczyść filtry",
    "resultCount": "{{count}} łowisk",
    "noResults": "Żadne łowisko nie pasuje do filtru.",
    "buyFiskekort": "Kup kartę",
    "seeVald": "Zobacz łowisko",
    "searchPlaceholder": "Szukaj łowiska lub rzeki",
    "sortLabel": "Sortuj",
    "sortName": "Nazwa (A-Z)",
    "sortPrice": "Cena"
  },
  "bliValdeier": {
    "title": "Zostań właścicielem łowiska",
    "lead": "Zostałeś/aś zaproszony/a na właściciela łowiska {{valdName}} na rzece {{riverName}}.",
    "vald": "Łowisko",
    "river": "Rzeka",
    "loginHint": "Zaloguj się kontem zarejestrowanym na zaproszony adres e-mail, aby zaakceptować.",
    "loginAndAccept": "Zaloguj się i zaakceptuj",
    "autoClaimHint": "Finalizowanie rejestracji…",
    "claiming": "Rejestrowanie własności…",
    "successTitle": "Witaj jako właściciel łowiska!",
    "successDesc": "Jesteś teraz zarejestrowany/a jako właściciel {{valdName}}.",
    "goToValdAdmin": "Przejdź do admin łowiska",
    "notFoundTitle": "Nie znaleziono zaproszenia",
    "notFoundDesc": "Link jest nieważny lub wygasł.",
    "expiredTitle": "Zaproszenie wygasło",
    "expiredDesc": "Poproś administratora o wysłanie nowego zaproszenia.",
    "claimedTitle": "Już użyte",
    "claimedDesc": "To zaproszenie zostało już zaakceptowane.",
    "errorTitle": "Coś poszło nie tak"
  },
  "komIGang": {
    "selectVald": "Wybierz łowisko",
    "chooseVald": "Wybierz łowisko",
    "step1Title": "Dane kontaktowe",
    "step1Desc": "Podaj dane kontaktowe i opis łowiska. Będą one widoczne publicznie.",
    "contactName": "Osoba kontaktowa",
    "contactNamePlaceholder": "Imię lub organizacja",
    "phone": "Telefon",
    "email": "E-mail",
    "website": "Strona internetowa",
    "description": "Opis",
    "descriptionPlaceholder": "Opisz łowisko, warunki wędkowania, zasady itp.",
    "step2Title": "Mapa i metody wędkowania",
    "step2Desc": "Umieść łowisko na mapie, narysuj granice i wybierz techniki wędkowania.",
    "mapLocation": "Pozycja na mapie (kliknij, aby umieścić)",
    "polygon": "Granica łowiska (opcjonalnie)",
    "flyFishing": "Odpowiednie do wędkowania muchówką",
    "boatFishing": "Wędkowanie z łodzi możliwe",
    "step3Title": "Stanowiska wędkarskie",
    "step3Desc": "Dodaj konkretne stanowiska wędkarskie na mapie (opcjonalnie).",
    "step3Hint": "Możesz dodawać stanowiska wędkarskie z panelu administracyjnego łowiska w dowolnym momencie.",
    "back": "Wstecz",
    "nextStep": "Następny krok",
    "skipWizard": "Pomiń",
    "goToValdAdmin": "Przejdź do admin łowiska"
  },
  "installPrompt": {
    "text": "Dodaj Lakseborsen do ekranu głównego, aby uzyskać szybszy dostęp",
    "iosHint": "Dodaj Lakseborsen do ekranu głównego: otwórz menu Udostępnij w przeglądarce i wybierz „Do ekranu początkowego”.",
    "install": "Dodaj",
    "dismiss": "Zamknij"
  },
  "textSize": {
    "label": "Rozmiar tekstu",
    "normal": "Normalny rozmiar tekstu",
    "large": "Duży rozmiar tekstu",
    "xlarge": "Bardzo duży rozmiar tekstu"
  },
  "statsSection": {
    "title": "Statystyki i wykresy",
    "yearLabel": "Sezon",
    "tooFewData": "Potrzeba więcej danych, aby wyświetlić tę statystykę",
    "noCatchesForYear": "Brak zarejestrowanych połowów w tym sezonie",
    "loading": "Ładowanie statystyk…",
    "axisCatches": "Połowy",
    "axisAvgWeight": "Średnia waga (kg)",
    "axisWeek": "Tydzień",
    "axisHour": "Godzina",
    "kpi": {
      "totalCatches": "Liczba połowów",
      "totalWeight": "Łączna waga",
      "avgWeight": "Średnia waga",
      "biggestFish": "Największa ryba",
      "releaseRate": "Odsetek wypuszczonych",
      "uniqueAnglers": "Aktywni wędkarze",
      "cpue": "Połowy na wędkarza",
      "fishingHours": "Godziny wędkowania",
      "catchesPerHour": "Połowy na godzinę",
      "anglersNow": "Wędkarze teraz"
    },
    "fishType": {
      "title": "Rozkład według gatunku ryb",
      "subtitle": "Liczba połowów według gatunku"
    },
    "gear": {
      "title": "Który sprzęt łowi najwięcej?",
      "subtitle": "Połowy według rodzaju sprzętu"
    },
    "weekly": {
      "title": "Kiedy w sezonie połów jest najlepszy?",
      "subtitle": "Połowy według tygodnia"
    },
    "hour": {
      "title": "O której porze dnia ryby biorą?",
      "subtitle": "Połowy według godziny"
    },
    "airTemp": {
      "title": "Temperatura powietrza a połowy",
      "subtitle": "Liczba połowów i średnia waga według temperatury"
    },
    "waterTemp": {
      "title": "Temperatura wody a połowy",
      "subtitle": "Liczba połowów i średnia waga według temperatury"
    },
    "waterFlow": {
      "title": "Przepływ wody a połowy",
      "subtitle": "Liczba połowów i średnia waga według poziomu przepływu"
    },
    "historicalHeader": "Przegląd historyczny",
    "yearly": {
      "title": "Połowy według sezonu",
      "subtitle": "Łączna liczba zarejestrowanych połowów, rok po roku"
    },
    "typical": {
      "title": "Typowy sezon a bieżący rok",
      "subtitle": "Średnia tygodniowa na podstawie {{yearCount}} historycznych sezonów",
      "avgLabel": "Średnia",
      "currentLabel": "{{year}}"
    },
    "biggest": {
      "title": "Największe połowy wszech czasów",
      "subtitle": "Top 10 — kliknij, aby zobaczyć połów"
    },
    "showAllCharts": "Pokaż wszystkie wykresy"
  },
  "notFound": {
    "title": "Nie znaleziono strony",
    "message": "Nie mogliśmy znaleźć szukanej strony.",
    "backHome": "Powrót do strony głównej"
  },
  "terms": {
    "title": "Warunki wędkowania",
    "accept": "Przeczytałem i akceptuję warunki",
    "mustAccept": "Aby kontynuować, musisz zaakceptować warunki.",
    "translationNote": "To jest tłumaczenie. W razie rozbieżności obowiązuje tekst norweski.",
    "noticeTitle": "Warunki wędkowania w systemie rzecznym",
    "noticeBody": "Dla tego systemu rzecznego ustalono warunki wędkowania, których jeszcze nie zaakceptowałeś. Obowiązują niezależnie od tego, gdzie kupiłeś kartę wędkarską. Nadal możesz zarejestrować swój połów.",
    "readAndAccept": "Przeczytaj i zaakceptuj warunki",
    "acceptNow": "Akceptuję warunki",
    "acceptFailed": "Nie udało się zapisać akceptacji. Spróbuj ponownie."
  },
  "checkin": {
    "intro": "Wędkujesz teraz? Rozpocznij wędkowanie, aby stowarzyszenie rzeki widziało, ile czasu wędkowania stoi za połowami.",
    "start": "Zacznij wędkować teraz",
    "end": "Zakończono wędkowanie",
    "active": "Wędkujesz w {{vald}}",
    "endFailed": "nie udało się zakończyć",
    "pickVald": "Najpierw wybierz vald poniżej.",
    "privacy": "Zapisujemy tylko czas, nie Twoją lokalizację.",
    "sessions": {
      "title": "Twoje sesje",
      "intro": "Zapomniałeś nacisnąć „Zacznij wędkować” lub „Zakończono wędkowanie”? Dodaj lub popraw sesję tutaj. Czasy są podawane samodzielnie, a sesje możesz dodawać z ostatnich 60 dni (maksymalnie 14 godzin każda).",
      "empty": "Brak sesji.",
      "add": "Dodaj sesję",
      "edit": "Edytuj",
      "delete": "Usuń",
      "confirmDelete": "Usunąć tę sesję?",
      "vald": "Vald",
      "start": "Początek",
      "end": "Koniec",
      "save": "Zapisz",
      "cancel": "Anuluj",
      "running": "W toku",
      "unknown": "Czas trwania nieznany: popraw sesję",
      "manual": "dodano ręcznie",
      "hm": "{{h}} godz. {{m}} min",
      "errors": {
        "end_before_start": "Koniec musi być po początku.",
        "too_long": "Sesja może trwać maksymalnie 14 godzin.",
        "in_future": "Czas nie może być w przyszłości.",
        "too_old": "Możesz dodawać tylko sesje z ostatnich 60 dni.",
        "overlap": "Ta sesja pokrywa się z inną Twoją sesją.",
        "open_session": "Zakończ sesję przyciskiem „Zakończono wędkowanie”.",
        "end_required": "Podaj, kiedy sesja się zakończyła.",
        "vald_not_found": "Nie znaleziono valdu.",
        "generic": "Nie udało się zapisać sesji. Spróbuj ponownie."
      }
    }
  },
  "elvekort": {
    "notFound": "Nie znaleziono elvekort.",
    "voluntary": "Elvekort jest dobrowolny. Nie potrzebujesz go, aby kupić kartę wędkarską ani zarejestrować połów.",
    "buy": "Kup elvekort",
    "validPeriod": "Ważny {{from}} – {{to}}",
    "myCards": "Moje elvekort",
    "offerTitle": "Elvekort dla systemu rzecznego",
    "confirmedTitle": "Elvekort zakupiony",
    "cancelledTitle": "Płatność została anulowana",
    "processing": "Przetwarzanie płatności…",
    "pendingHint": "Płatność nie została jeszcze potwierdzona. Sprawdź za chwilę „Moje elvekort”."
  },
  "riversPage": {
    "metaTitle": "Rzeki i rewiry – rzeki łososiowe w Norwegii | Lakseborsen",
    "metaDescription": "Przegląd rzek łososiowych i rewirów z zezwoleniami, sezonem i noclegami.",
    "title": "Rzeki i rewiry",
    "intro": "Wszystkie rzeki w Lakseborsen wraz z rewirami. Wybierz rzekę, by zobaczyć sezon, zasady, noclegi i miejsca, gdzie można zjeść w pobliżu.",
    "closed": "Tymczasowo zamknięta",
    "valds": "Rewiry",
    "seeRiver": "Zobacz {{river}}",
    "aboutRiver": "O rzece",
    "valdsCount": "{{count}} rewirów"
  }
}
